module.exports = __webpack_public_path__ + "static/img/23_ziwaixian.e83dff69.png";